// The ACC cloud: blue and filled when the project is linked to a file in ACC
// (or the Autodesk account is connected), grey outline otherwise.
import React from "react";

export default function AccCloudIcon({ active = false, size = 18, title }) {
  const c = active ? "#0696D7" : "#9E9E9E";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" aria-label={title || (active ? "Linked to ACC" : "Not linked to ACC")}>
      {title ? <title>{title}</title> : null}
      <path
        d="M17.5 19H7a5 5 0 0 1-.9-9.92A6.5 6.5 0 0 1 18.6 8.6 4.5 4.5 0 0 1 17.5 19Z"
        fill={active ? c : "none"}
        stroke={c}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      {active ? <path d="M9 13.5l2 2 4-4" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /> : null}
    </svg>
  );
}
